<template>
    <div class="header d-flex flex-grow-1 justify-space-between align-center">
        <div class="menu">
            <single-page-part :pagePart="headerLeftMenu"/>
        </div>
        <div class="logo">
            <router-link :to="mainPageUrl">
                <img class="desc" :src="logotypePath" :alt="mainPageAlt" :class="{ramadan: isRamadan}">
                <img class="mob" :src="mobileLogotypePath" :alt="mainPageAlt" :class="{ramadan: isRamadan}">
            </router-link>
        </div>
        <div class="header__nav">
            <the-user-header v-if="user"/>

            <sign-in v-else/>
        </div>

        <v-dialog v-model="$store.state.signIn.checkConfirmSignupDialog" max-width="900px"
                  :persistent="isDialogPersistent" v-if="$store.state.signIn.checkConfirmSignupDialog">
            <check-confirm-signup/>
        </v-dialog>

        <v-dialog v-model="$store.state.signIn.successConfirmSignupDialog" max-width="900px"
                  :persistent="isDialogPersistent" v-if="$store.state.signIn.successConfirmSignupDialog">
            <success-confirm-signup/>
        </v-dialog>

        <v-dialog v-model="$store.state.signIn.failedConfirmSignupDialog" max-width="472px"
                  :persistent="isDialogPersistent" v-if="$store.state.signIn.failedConfirmSignupDialog">
            <failed-confirm-signup/>
        </v-dialog>
    </div>
</template>

<script>
import {appName, brandName, events} from '../../../config/app';
import Toaster from "../../mixins/toaster";
import DialogSettings from "../../mixins/dialogSettings";

export default {
    name: "TheMainHeader",

    mixins: [Toaster, DialogSettings],

    data: function () {
        return {
            userMenuDrawer: false,
        };
    },

    computed: {
        isHalloween() {
            return events.halloween;
        },

        isChristmas() {
            return events.christmas;
        },

        isEaster() {
            return events.easter;
        },

        isRamadan() {
            return events.ramadan;
        },

        isGrandEID() {
            return events.grandEID;
        },

        logotypePath() {
            if (this.isHalloween) {
                return `/public/${brandName}/halloween/logo-header.svg`;
            } else if (this.isChristmas) {
                return `/public/${brandName}/christmas/logo-header.svg`;
            } else if (this.isEaster) {
                return `/public/${brandName}/easter/logo-header.svg`;
            } else if (this.isRamadan) {
                return `/public/${brandName}/ramadan/logo-header.svg`;
            } else if (this.isGrandEID) {
                return `/public/${brandName}/grand-eid/logo-header.svg`;
            } else {
                return `/public/${brandName}/logotype/logo-header.svg`;
            }
        },

        mobileLogotypePath() {
            if (this.isHalloween) {
                return `/public/${brandName}/halloween/logo-header-mob.svg`;
            } else if (this.isChristmas) {
                return `/public/${brandName}/christmas/logo-header-mob.svg`;
            } else if (this.isEaster) {
                return `/public/${brandName}/easter/logo-header-mob.svg`;
            } else if (this.isRamadan) {
                return `/public/${brandName}/ramadan/logo-header-mob.svg`;
            } else if (this.isGrandEID) {
                return `/public/${brandName}/grand-eid/logo-header-mob.svg`;
            } else {
                return `/public/${brandName}/logotype/logo-header-mob.svg`;
            }
        },

        user() {
            return this.$store.state.user;
        },

        headerLeftMenu() {
            return this.$store.getters.getLayoutPagePart('headerLeftMenu');
        },

        mainPageUrl() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix() || '/';
            return `${languageUrlPrefix}`;
        },

        mainPageAlt() {
            return appName;
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/layout/TheMainHeader"
</style>
